import React, { HTMLProps } from 'react';

const CloudUploadIcon = (props: HTMLProps<SVGSVGElement>) => (
    <svg
        {...props}
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="Icons"
            stroke="inherit"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g id="Icon-/-cloud-upload" stroke="inherit">
                <path
                    d="M14.79375,16.5 C14.79375,16.5 17.59875,16.6075 18.6925,16.125 C20.2447974,15.4216257 21.3056779,
                    13.9455353 21.4775,12.25 C21.64125,10.61375 20.895,8.81625 19.485,7.94625 C18.78375,7.515 17.965,7.34 17.14625,
                    7.26875 C16.6791058,7.25616428 16.2116601,7.27705104 15.7475,7.33125 C15.6173286,6.91664171 15.4385876,
                    6.51888013 15.215,6.14625 C14.3139883,4.64775699 12.7495288,3.67171273 11.0075,3.52125 C9.30250602,
                    3.39742911 7.64169227,4.09950883 6.5425,5.40875 C6.01186055,6.04324656 5.63116442,6.78925716 5.42875,
                    7.59125 C5.375,7.80375 5.26875,8.39625 5.26875,8.39625 C4.72163253,8.57177257 4.21654831,8.85814298 3.785,
                    9.2375 C2.47125,10.4125 2.15125,12.42 2.88625,14 C3.55375,15.435 4.9875,16.5 6.5825,16.5 L9.2075,16.5 M12,20 L12,
                    9.5 M8.75,13 L12,9.5 L15.25,13" // tslint:disable-line
                    id="7bc71e71-c1c2-4883-a80f-08fb219dc34b-2"
                />
            </g>
        </g>
    </svg>
);

export default CloudUploadIcon;
